import classnames from 'classnames';
import dynamic from 'next/dynamic';
import capitalize from 'lodash/capitalize';
import styles from './flag.module.scss';
import { FlagProps } from './flag.types';

const Flag = ({
  /* props */
  territory,
  classNames = [],
  nativeProps = {},
}: FlagProps) => {
  const classes = classnames([styles.flag], classNames);
  const FlagWithTerritory = dynamic<{ className: string }>(
    () =>
      /* @vite-ignore */
      import(
        `@stadionhq-v3/scottishfa-web-tokens/dist/components/icons/${capitalize(territory)}.tsx`
      )
  );

  return <FlagWithTerritory {...nativeProps} className={classes} />;
};

export default Flag;
